function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M7 3a1 1 0 000 2h5v4c0 1.1.9 2 2 2h6.9l-.8 6H20h-.2a3 3 0 00-5.6 0H10h-.2a3 3 0 00-5.6 0H2a1 1 0 100 2h2.2a3 3 0 005.6 0h4.4a3 3 0 005.6 0H20.1a2 2 0 002-1.8l.8-6.6a2 2 0 00-.4-1.6L18 3.7a2 2 0 00-1.6-.7H7zm12.9 6l-3.4-4H14v4h5.9zM16 18a1 1 0 112 0 1 1 0 01-2 0zm-9-1a1 1 0 100 2 1 1 0 000-2z",
  clipRule: "evenodd"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M2 10c0-.6.4-1 1-1h4a1 1 0 010 2H3a1 1 0 01-1-1zM4 7c0-.6.4-1 1-1h4a1 1 0 010 2H5a1 1 0 01-1-1z"
});

var SvgIcoDelivery24 = function SvgIcoDelivery24(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcoDelivery24, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ico-delivery-24.46fffc72.svg";
export { ForwardRef as ReactComponent };